import { render } from "./ProductImage.vue?vue&type=template&id=9b43f368&scoped=true"
import script from "./ProductImage.vue?vue&type=script&lang=js"
export * from "./ProductImage.vue?vue&type=script&lang=js"

import "./ProductImage.vue?vue&type=style&index=0&id=9b43f368&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b43f368"]])

export default __exports__